module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-01-a41087ca45b80de7d4c82037f582dbfb.jpg";